export default function engine() {
  article_init();
}

function article_init() {
  // Remove any empty paragraphs made from rogue returns
  $('p').each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;|\<br\>/g, '').length == 0) {
      $this.remove();
    }
  });
}

export function log(message) {
  if (config.logging == true) {
    console.log(message);
  }
}
